














import { Component, Vue } from 'vue-property-decorator';
import storage from '../../utils/storage';
import Loading from '../../components/Loading.vue';
import qiniuyun from '../../utils/qiniuyun';
import checkLogin from '../../utils/checkLogin';
import tableModel from '../../components/table/tableModel.vue';
@Component({
  components: {
    Loading,
    tableModel,
  },
})
export default class Qiniu extends Vue {
  private user: any;
  private spinning = false;
  private maskClosable: boolean = false;
  private visible: boolean = false;
  private headers: any = {
    authorization: 'authorization-text',
  };
  private columns: any = [{
    title: 'ID',
    dataIndex: 'id',
    width: '7%',
    scopedSlots: { customRender: 'ID' },
  },
  {
    title: '下载链接',
    dataIndex: 'title',
    width: '60%',
    scopedSlots: { customRender: 'title' },
  },
  {
    title: 'CreateTime',
    dataIndex: 'createTime',
    width: '30%',
    scopedSlots: { customRender: 'createTime' },
  },
  ];
  private dataJson: any = [];
  private  mounted() {
    this.user = storage.get('user');
    if (this.user) {
      checkLogin();
      this.getData();
    } else {
     this.$router.push({
        path: '/login',
      });
    }
  }
  private getData() {
    this.spinning = true;
    const that = this;
    const url: string = '/api/getUploadFileData';
    const args = {
    };
    this.axios.post(url, args).then((res: any) => {
      that.dataJson = res.data.data ;
      this.spinning = false;
    }).catch((err) => {
      console.log(err);
      this.spinning = false;
    });
  }
  private async getQiniu(req: any) {
    this.spinning = true;
    try {
      // 组件获取到的图片信息, 文件名字开头部分.
      const data: any = await qiniuyun(req, 'Other_');
      // tslint:disable-next-line:no-string-literal
      const fileLink = 'http://fzeni.com/' + data['key'];
      console.log(fileLink);
      // 上传链接到服务器
      await this.pushFileLink(fileLink);
      this.getData();
    } catch (err) {
      this.$message.warning(err);
      this.spinning = false;
    }
  }
  private pushFileLink(title: string) {
    return new Promise((resolve, reject) => {
      const url: string = '/api/saveFilePath';
      const args = {
        title,
      };
      this.axios.post(url, args).then((res: any) => {
        resolve(res);
      }).catch((err) => {
        reject(err);
      });
    });
  }
}
